<app-search-bar ></app-search-bar>
<router-outlet></router-outlet>
<app-search-results></app-search-results>
